// This file added by Bearer Web Developer - Schedule as a Future Order
import React from 'react';
import styles from './scheduleOrder.module.scss';
import BearerCheckboxField from '../../../components/fields/BearerCheckboxField';
import { useAppState } from '../../../states/app-state';
import { observer } from "mobx-react-lite";
import ScheduleEditor from './scheduleEditor';
import ScheduleCompact from './scheduleCompact';
import { Button } from '@mui/material';
import { EarliestEnum, TimeSensitiveEnum } from '../../../states/scheduleOrderstate';

const ScheduleOrder: React.FC = observer(() => {

    const appstate = useAppState();
    const order = appstate?.selectedOrder;
    const scheduleOrder = appstate?.selectedOrder?.scheduleOrder;
    const editing = scheduleOrder?.editing;
    const isDisabled = scheduleOrder?.isDisabled;
    const isReadyForPayment = order?.isReadyForPayment;
    const handleChange = () => {
        if (scheduleOrder?.timeSensitive || !isReadyForPayment) return;
        if (scheduleOrder) {
            scheduleOrder.setSchedule(!scheduleOrder?.schedule);
            scheduleOrder.setEditing(!scheduleOrder?.schedule);
        }
    }
    // console.log(scheduleOrder?.timeSensitive)
    const checked = !!(scheduleOrder?.timeSensitive || scheduleOrder?.schedule);
    const pastDue = (
        scheduleOrder?.timeSensitive === TimeSensitiveEnum.PastDue ||
        scheduleOrder?.timeSensitive === TimeSensitiveEnum.DueTodayPastTime
    ) && !editing && !isDisabled;
    return (
        <section className={styles.schedule_order}>
            <div className={styles.header}>
                {
                    pastDue ?
                        <div className={styles.past_due}>
                            <h3>Schedule Order</h3>
                            <div className={styles.priority_high}>
                                <img src="/priority-high.svg" alt="" width={20} height={20} />
                            </div>
                        </div>
                        : <h3>Schedule Order</h3>
                }
                {!isDisabled && !editing && scheduleOrder?.schedule &&
                    <Button className={styles.edit}
                        onClick={() => {
                            if (pastDue && scheduleOrder?.earliestPickup === EarliestEnum.PickADate) {
                                scheduleOrder?.toggleEarliestPickup(EarliestEnum?.Now, true);
                            }
                            if (!editing) scheduleOrder?.setEditing(true);
                        }}
                    >Edit</Button>
                }
            </div>
            {pastDue &&
                <div className={styles.note}>
                    <img src="/note.svg" alt="" width={22} height={22} />
                    <p>You should update your pickup time range by clicking on “Edit” button.</p>
                </div>
            }
            {(editing || !scheduleOrder?.schedule) &&
                <div className={styles.input_part}>
                    <BearerCheckboxField disabled={!isReadyForPayment} label="Time-Sensitive / Future Order"
                        checked={checked} handleChange={handleChange} />
                </div>
            }
            {scheduleOrder?.schedule && <>{editing ? <ScheduleEditor /> : <ScheduleCompact />}</>}
        </section>
    )
})
export default ScheduleOrder;